import { Feature } from './hotelConfig.model';

export enum FeatureKey {
  ROOM = 'room',
  RECEPTION = 'reception',
  RESERVATION = 'reservation',
  CLEANING = 'cleaning',
  MAINTENANCE = 'maintenance',
  ORDER = 'roomService',
  CUSTOM_MODULES = 'customModules',
  ECOMMERCE = 'ecommerce',
  PROMOTIONS = 'promotions',
  IMMEDIATE = 'immediate',
  SPECIAL = 'special',
  CUSTOM = 'custom',
  PAYMENTS = 'payments',
  PRE_STAY = 'preStay',
  REQUEST = 'requests',
  EVENTS = 'events',
  PERSONALIZE = 'personalize',
  CHAT_ASSISTANT = 'chatAssistant',
  VOICE_ASSISTANT = 'voiceAssistant',
}

export const FeatureKeyTranslations = {
  [FeatureKey.ORDER]: 'menu.roomService',
  [FeatureKey.ECOMMERCE]: 'menu.ecommerce',
};

export const FeatureKeys = Array.from(Object.values(FeatureKey));

export const initialFeatures: Feature[] = FeatureKeys.map((key) => ({
  key,
  name: 'feature.' + key,
  enabled: true,
}));
